export const tabs = [
  { key: 'tasks', label: 'Задания' },
  { key: 'messages', label: 'Тексты' },
  { key: 'workers', label: 'Исполнители' },
  { key: 'settings', label: 'Настройки' },
];
export const statuses = {
  scheduled: 'Запланировано',
  waiting: 'Ожидает предыдущее',
  attempting: 'Передаётся в UNU',
  submitted: 'Передано в UNU',
  taken: 'В работе',
  review: 'Отчёт на проверке',
  done: 'Завершено',
  failed: 'Ошибка',
  unknown: 'Результат неизвестен — без повтора',
  cancelled: 'Отменено',
};
export function errorText(error) {
  const code = error?.response?.data?.error;
  const messages = {
    administrator_required: 'Нет доступа к разделу.',
    connection_unavailable: 'UNU не подключён для этого кабинета.',
    connection_disabled: 'Подключение UNU выключено.',
    tariff_unavailable: 'Тариф ещё не обновлён. Синхронизируйте данные.',
    price_changed: 'Тариф изменился. Обновите данные и проверьте стоимость.',
    insufficient_balance:
      'Недостаточно средств с учётом запланированных заданий.',
    invalid_text: 'Текст должен содержать от 1 до 150 символов.',
    invalid_date: 'Укажите будущее время начала, не раньше чем через минуту.',
    invalid_targeting: 'Проверьте пол и возраст исполнителя.',
    invalid_price: 'Не удалось определить стоимость.',
    invalid_messages: 'Проверьте тексты: до 500 строк, каждая до 150 символов.',
    message_limit: 'Лимит библиотеки группы — 5000 текстов.',
    group_unavailable:
      'У группы нет действующего подключения или публичной ссылки.',
    group_disabled: 'Задания UNU для этой группы выключены.',
    revision_conflict: 'Данные изменились. Обновите страницу.',
    request_conflict: 'Запрос уже сохранён с другими данными. Обновите список.',
    task_already_dispatched:
      'Задание уже передано или его результат неизвестен. Повтор запрещён.',
    missed_schedule: 'Задание просрочено больше суток. Укажите новое время.',
    pending_limit: 'Достигнут лимит ожидающих заданий.',
    sync_rate_limited: 'Синхронизация уже запущена. Подождите.',
    provider_connection_error: 'UNU временно недоступен.',
    provider_rejected: 'UNU отклонил запрос. Проверьте кабинет UNU.',
    provider_moderation_rejected: 'Задание отклонено модерацией UNU.',
    provider_paused: 'Заказ остановлен в UNU.',
    dispatch_interrupted:
      'Связь прервалась при отправке. Сверьте заказ в UNU, повтор отключён.',
    dispatch_result_unconfirmed:
      'Результат заказа неизвестен. Сверьте его в UNU; повтора не будет.',
    task_id_unconfirmed: 'UNU не подтвердил номер заказа. Повтор отключён.',
    sync_failed: 'Ошибка синхронизации.',
    provider_rate_limited: 'UNU ограничил частоту запросов. Подождите.',
    provider_http_error: 'UNU временно недоступен.',
    key_unavailable: 'Серверное подключение UNU недоступно.',
  };
  return (
    messages[code] ||
    (error?.response?.status === 403
      ? 'Нет доступа к разделу.'
      : 'Не удалось выполнить действие. Обновите данные перед повтором.')
  );
}
export function normalizeTab(value) {
  return tabs.some(item => item.key === value) ? value : 'tasks';
}
export function validateTask(task) {
  if (!task.text.trim()) return 'Введите текст задания или выберите заготовку.';
  if (task.text.trim().length > 150)
    return 'В тексте должно быть не больше 150 символов.';
  if (
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(task.plannedAt) ||
    Number.isNaN(Date.parse(`${task.plannedAt}:00+03:00`))
  )
    return 'Укажите дату и время.';
  if (
    task.age !== '' &&
    (!Number.isInteger(Number(task.age)) ||
      Number(task.age) < 16 ||
      Number(task.age) > 60)
  )
    return 'Возраст должен быть от 16 до 60 лет.';
  return '';
}
export function parseMessages(text) {
  const lines = text
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
  if (!lines.length)
    return { error: 'Добавьте хотя бы один текст.', items: [] };
  if (lines.length > 500)
    return { error: 'За один раз можно добавить до 500 текстов.', items: [] };
  if (lines.some(line => line.length > 150))
    return {
      error: 'Каждый текст должен быть не длиннее 150 символов.',
      items: [],
    };
  return { error: '', items: [...new Set(lines)] };
}
